import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createTrainer } from "../pages/services/trainerService";
import "../styles/AddForm.css";

const Field = ({ label, required, error, children }) => (
  <div className="af-field">
    <label className="af-label">
      {label}{required && <span className="af-required">*</span>}
    </label>
    {children}
    {error && <span className="af-error">{error}</span>}
  </div>
);

const AddTrainer = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ trainerName: "", contactNumber: "" });
  const [errors, setErrors]     = useState({});
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading]   = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(p => ({ ...p, [name]: value }));
    setErrors(p => ({ ...p, [name]: "" }));
  };

  const validate = () => {
    const errs = {};
    if (!formData.trainerName.trim()) errs.trainerName = "Trainer name is required";
    if (formData.contactNumber && !/^\d{10}$/.test(formData.contactNumber.trim())) {
      errs.contactNumber = "Enter a valid 10-digit mobile number";
    }
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setLoading(true);
    setErrorMsg("");
    try {
      await createTrainer({
        trainerName: formData.trainerName.trim(),
        contactNumber: formData.contactNumber.trim() || null,
      });
      navigate("/trainers", { state: { successMessage: `Trainer "${formData.trainerName.trim()}" added successfully!` } });
    } catch (err) {
      setErrorMsg(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="af-page">
      {loading && (
        <div className="af-overlay">
          <div className="af-spinner" />
          <p className="af-overlay-text">Saving trainer…</p>
        </div>
      )}

      <div className="af-card">
        <div className="af-header">
          <div className="af-header-icon violet">🎓</div>
          <div className="af-header-text">
            <h2 className="af-title">Add New Trainer</h2>
            <p className="af-subtitle">Fill in the details to register a trainer</p>
          </div>
        </div>

        {errorMsg && (
          <div className="af-alert af-alert-error" style={{ margin: "16px 32px 0" }}>{errorMsg}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="af-body">
            <div className="af-section">
              <p className="af-section-title">Trainer Information</p>

              <Field label="Full Name" required error={errors.trainerName}>
                <input
                  type="text"
                  name="trainerName"
                  placeholder="e.g. Priya Sharma"
                  value={formData.trainerName}
                  onChange={handleChange}
                  className={errors.trainerName ? "error-input" : ""}
                />
              </Field>

              <Field label="WhatsApp / Contact Number" error={errors.contactNumber}>
                <input
                  type="tel"
                  name="contactNumber"
                  placeholder="10-digit mobile number (used for OTP login)"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  className={errors.contactNumber ? "error-input" : ""}
                  maxLength={10}
                />
                <span style={{ fontSize: 12, color: "#64748b", marginTop: 4, display: "block" }}>
                  The trainer will use this number to log in to the Trainer Portal via OTP.
                </span>
              </Field>
            </div>
          </div>

          <div className="af-submit-row" style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <button type="button" className="af-cancel-btn" onClick={() => navigate("/trainers")} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="af-submit" style={{ width: "auto", flex: 1 }} disabled={loading}>
              {loading ? "Saving…" : "Add Trainer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTrainer;
